export default __webpack_public_path__ + "static/media/sheran-hesckel.8cf37d22.png";